module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/yxjfhD/tc-custom/9781625850812.jpg?1705026147365",
      "alt": "This image is the cover for the book The Kelayres Massacre: Politics & Murder in Pennsylvania's Anthracite Coal Country, True Crime"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Kelayres Massacre: Politics & Murder in Pennsylvania's Anthracite Coal Country, True Crime\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Politics in Kelayres turned deadly on November 5, 1934. When Republican boss \"Big Joe\" Bruno sensed his grip on Pennsylvania's anthracite coal region slipping away with the night's election, he and a few family members opened fire on a peaceful Democratic parade passing Bruno's home. The carnage was shocking--five men gunned down and nearly two dozen other victims wounded but alive. Convicted and sentenced to the Schuylkill County Prison, Bruno quickly escaped, allegedly with help from the guard. It took authorities eight months to put him back behind bars. Author Stephanie Hoover delves into this true story of politics, murder and deceit.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Stephanie Hoover\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Stephanie Hoover is a professional writer and researcher specializing in Pennsylvania history, genealogy and culture. She has written over two hundred articles for local and national newspapers and magazines. Stephanie is the author of \"The Killing of John Sharpless\" and \"Philadelphia Spiritualism and the Curious Case of Katie King.\" She also owns and writes for Hauntingly Pennsylvania, Where History and Hauntings Meet, Pennsylvania Research and Prose 'n' Cons Magazine. She lives in Harrisburg, Pennsylvania.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0